









import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UploadCsvFile extends Vue {
  @Prop({ type: File, required: false }) value!: File;
}
